<agpr-take-over-panel
    *ngIf="recipient_"
    id="recpientViewer"
    [header]="'Discover.recipientViewer.header' | localize: {name : recipient_.label}"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close()"
>
    <div
        class="agpr-recipientViewer"
        [agprLoading]="loading"
    >
        <div class="agpr-recipientViewer-center">
            <agpr-tabs
                class="agpr-recipientViewer-tabs"
                [variableHeaderWidth]="true"
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="tabChange($event)"
            >
                <agpr-tab
                    [heading]="'Discover.distribution.recipientTab.recipients' | localize : {count: total}"
                    [id]="'recipientViewer.tab.contacts'"
                ></agpr-tab>
                <agpr-tab
                    [heading]="'Discover.distribution.recipientTab.exclusions' | localize : {count: excludedTotal}"
                    [id]="'recipientViewer.tab.others'"
                ></agpr-tab>
            </agpr-tabs>
            <!-- top row -->
            <div class="agpr-recipientViewer-filterToolbar">
                <div class="agpr-recipientViewer-filterToolbar-filterInput">
                    <agpr-filter-dropdown
                        id="'recipientViewer_filter'"
                        [showQuickFilter]="true"
                        quickFilterPlaceholder="Discover.targeting.filter.quick.contactName.placeholder"
                        [ariaLabel]="'Discover.targeting.filter.quick.contactName.placeholder' | localize"
                        [ariaDescribedBy]="'recipientViewer_filter_chips'"
                    >
                    </agpr-filter-dropdown>
                    <agpr-filter-chips
                        #filterChipsComponent
                        [id]="'recipientViewer_filter_chips'"
                    ></agpr-filter-chips>
                    <agpr-button
                        [id]="'recipientViewer_filter_clearAll'"
                        *ngIf="filterChipsComponent.chips.length > 1"
                        class="agpr-recipientViewer-filterToolbar-filterInput-clear"
                        [style]="buttonTypes.icon"
                        (click)="clearFilters()"
                        icon="fa-kit-duotone fa-agpr-remove-all"
                        tooltip="Discover.targeting.filter.tooltip.clearAll"
                        tooltipPosition="top"
                    ></agpr-button>
                </div>
                <agpr-sort-order
                    id="recipientView-sortOrder"
                    [isDisabled]="!total || (!excludedTotal && selectedTabIndex === recipientViewerTabs.exclusionsTab)"
                    tooltip="Discover.targeting.tooltips.sort"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
            </div>
            <div class="agpr-recipientViewer-filterToolbar agpr-recipientViewer-filterToolbar-bottom">
                <div class="agpr-recipientViewer-filterToolbar-totalCount">
                    <span class="agpr-recipientViewer-filterToolbar-totalCount-total">{{ filteredTotal }}</span>{{ 'Discover.recipientViewer.totalCount' | localize}}
                </div>
                <agpr-paginator id="recipientView-paginator"></agpr-paginator>
            </div>
            <agpr-tabs
                *ngIf="selectedTabIndex === recipientViewerTabs.exclusionsTab && excludedContactTotal > 0 && excludedOutletTotal > 0"
                class="agpr-recipientViewer-tabs agpr-recipientViewer-tabs-exclusions"
                [variableHeaderWidth]="true"
                [selectedTabIndex]="selectedExclusionsTabIndex"
                (selectedTabIndexChange)="exclusionsTabChange($event)"
            >
                <agpr-tab
                    [heading]="'Discover.distribution.recipientTab.exclusions.contacts' | localize: {count: excludedContactTotal}"
                    [id]="'recipientViewer.exclusions.tab.contacts'"
                ></agpr-tab>
                <agpr-tab
                    [heading]="'Discover.distribution.recipientTab.exclusions.outlets' | localize: {count: excludedOutletTotal}"
                    [id]="'recipientViewer.exclusions.tab.outlets'"
                ></agpr-tab>
            </agpr-tabs>

            @if (results?.length === 0) {
                <agpr-message
                    class="agpr-recipientViewer-noContent"
                    [severity]="messageSeverityEnum.noContent"
                >
                    <span class="agpr-recipientViewer-noContent-text">
                        {{ 'Discover.distribution.recipientTab.noContent' | localize }}
                    </span>
                </agpr-message>
            }

            <agpr-scroll-panel
                class="agpr-recipientViewer-scrollpanel"
            >
                <ul
                    id="recipientView_recipients"
                    class="agpr-recipientViewer-cardContainer"
                    agprListKeyboardNavigation
                    [focusOnChild]="true"
                    [list]="results"
                    focusableElementCustomSelector=".agpr-targetingResults-card"
                >
                    <li *ngFor="let result of results; let i = index">
                        <agpr-recipient-viewer-card
                            [id]="'recipientViewerCard_' + i"
                            [entity]="result"
                            [recipient]="recipient_"
                            (focus)="cardFocused($event)"
                        >
                        </agpr-recipient-viewer-card>
                    </li>
                </ul>
            </agpr-scroll-panel>
        </div>
        <aside class="agpr-recipientViewer-sidebar">
            <agpr-rhp-contexts
                [id]="'recipientViewer_rhp'"
                [overlayContainer]="overlayContainer"
                [(selectedTabIndex)]="rhpSelectedTabIndex"
                [disableContentToggle]="true"
                [showFooter]="false"
                [fullHeightTakeover]="true"
            ></agpr-rhp-contexts>
        </aside>
    </div>
    <ng-template #takeOverFooterRight>
        <agpr-button
            (click)="close()"
            label="done"
            [style]="buttonTypes.primary"
            id="doneButton"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
